<template>
  <div>
    <!-- 头部 -->
    <top></top>
    <div class="main">
      <navMenu :active="active"></navMenu>
      <div class="content">
        <div class="go-back"  @click="goBack">返回</div>
          <div class="txt_box">您一共能上传{{product_max}}个展品信息，已上传{{totals}}个，还能上传{{allow_product}}个</div>
        <div class="header_box">
            <div style="width: 100%;">
              <div class="main-title">产品管理</div>
                <!-- <div class="main-sub">
                  请在此页面内为您的单位提供详细的展示资料，以便于专业买家在BCEIA平台上查询与筛选时更好的展现。
                </div> -->
            </div>
            <div class="right_box">
            <div class="times">提交截止日期：{{ detail.deadline }}</div>
          <div class="create-btn" @click="toLink('/createProduct')">
            创建产品
          </div>
            </div>
        </div>
         
      
        <!-- 搜索 -->
        <div class="search-wrap">
          <div class="search-input">
             <el-row>
              <el-col :span="8" :xs="24" class="search_item">
                <span>产品类型：</span>
                <el-cascader style="width: 100%;" :options="menuOptions" v-model="searchs.types" clearable :props="optionProps"></el-cascader>
              </el-col>
              <el-col :span="8" :xs="24"  class="search_item">
                <span>产品名称（中文）：</span>
                <el-input placeholder="请输入产品名称（中文）" v-model="searchs.name_cn"></el-input>
              </el-col>
              <el-col :span="8" :xs="24" class="search_item">
                <span>产品名称（英文）：</span>
                <el-input placeholder="请输入产品名称（英文）" v-model="searchs.name_en"></el-input>
              </el-col>
              <el-col :span="8" :xs="24" class="search_item">
                <span>届别：</span>
                <el-select  v-model="searchs.session_expo" placeholder="请选择" style="width: 100%;">
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.name"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-col>
              <el-col :span="16"  :xs="24" class="search_item" style="justify-content: end">
                <div class="search-btn reset" @click="reset">重置</div>
                  <div class="search-btn search" @click="search">搜索</div>
              </el-col>
             </el-row>
             
            
          </div>
          
        </div>
          <!-- 新列表 -->
           <div class="p_list">
            <template v-if="tableData.length>0">
              <div class="p_item" v-for="(item,index) in tableData" :key="index">
               <div class="p_item_top">
                <div>ID：{{ item.id }}</div>

               </div>
               <div class="p_item_scoend">
                  <img :src="$imgUrl+item.imgs"/>
                  <div>
                    <div class="goods_name">{{ item.name_cn }}</div>
                    <div class="tname">{{ item.type_name1 }}</div>
                    <div class="inputtime">添加时间：{{ item.create_time }}</div>
                  </div>
               </div>
               <div class="p_footer">
                <div class="p_item_footer check-btn"  @click="edit(item)">编辑</div>
                <div class="p_item_footer check-del"  @click="del(index, item)">删除</div>
               </div>
               

            </div>
            </template>
            <nodata v-else></nodata>
            
           </div>
           <div class="pagination_box">
            <el-pagination
                @current-change="handleCurrentChange"
                :current-page.sync="currentPage"
                :page-size="pagesize"
                layout="total, prev, pager, next"
                :total="totals"
              >
              </el-pagination>
           </div>
           <!-- <div class="list">


           </div> -->
        <!-- 列表 -->
        <!-- <div class="invitation-table pd">
          <el-table
            class="my-table"
            :data="tableData"
            stripe
            v-loading="loading"
            style="width: 100%; min-height: 600px"
            :header-cell-style="{
              textAlign: 'center',
              color: '#3A3A3C',
              fontWeight: 'normal',
              fontSize: '14px',
            }"
            :cell-style="{ textAlign: 'center',fontSize: '14px', }"
          >
            <el-table-column type="selection" width="55"> </el-table-column>
            <el-table-column
              prop="id"
              label="ID"
              width="100"
              sortable
            ></el-table-column>
            <el-table-column label="照片">
              <template slot-scope="scope">
                <el-image
                  :src="scope.row.img"
                  style="width: 69px; height: 69px; display: block;margin: 0 auto;"
                ></el-image>
              </template>
            </el-table-column>
            <el-table-column
              prop="goodsName"
              label="产品名称"
              sortable
            ></el-table-column>
            <el-table-column
              label="产品分类"
            >
              <template slot-scope="scope">
                <div>{{scope.row.product_type[0].tname ? scope.row.product_type[0].tname : '-'}}</div>
              </template>
            </el-table-column>
            <el-table-column
              label="状态"
            >
              <template slot-scope="scope">
                <div>{{scope.row.status ? '上架' : '下架'}}</div>
              </template>
            </el-table-column>
            <el-table-column
              prop="inputtime"
              label="添加时间"
              sortable
              width="200"
            ></el-table-column>
            <el-table-column label="操作" width="200">
              <template slot-scope="scope">
                <span class="check-btn" @click="edit(scope.row)"
                  >编辑</span
                >
                <span class="check-btn check-del" @click="del(scope.$index, scope.row)"
                  >删除</span
                >
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage"
            :page-size="pagesize"
            layout="total, prev, pager, next, jumper"
            :total="totals"
          >
          </el-pagination>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import { productList, productType, delproduct,productTypelist } from "@/api/api";
import top from "../components/top.vue"; //头部
import navMenu from "../components/navMenu.vue"; //左侧步骤条
import nodata from "../components/nodata.vue"; //头部
export default {
  components: { top, navMenu,nodata },
  name: "productList",
  data() {
    return {
      options:[],
      menuOptions:[],
      optionProps:{
        value: "id",
        label: "name_cn",
        children: "children",
    },
      searchs:{
        types:[],
        session_expo:'',
        type_1: '',
        type_2: '',
        type_3: '',
        name_cn: '',
        name_en: ''
      },
      status:'0',
      loading: false,
      active: 3,
      keywords: "",
      totals: 0,
      tableData: [],
      currentPage: 1,
      page: 1,
      pagesize: 10,
      typeList: [],
      mark:'',
        detail:{},
        product_max:"",
        allow_product:""
    };
  },
  mounted() {
    this.options = JSON.parse(localStorage.getItem("dictdata")).session_type;
    let stepMenuList = JSON.parse(localStorage.getItem("menu"));
    this.stepMenuList = stepMenuList;
    var index = stepMenuList.findIndex(function (item) {
      return item.link_url == "/standPrepare";
    });
      this.detail=stepMenuList[index].children[1];
    this.active = index;
    // 获取产品分类
    // this.getType();
    this.page = 1;
    this.mark=this.$route.query.mark;
    // 获取列表
    this.getList(this.page, this.searchs);
    this.productTypelist()
  },
  created() {},
  methods: {
    productTypelist(){
      productTypelist({}).then(res=>{
        if(res.code == 1){
          this.menuOptions=res.data.lists;
        }

      }).catch(err=>{
        console.log(err)
      })
    },
    //搜索
    search(){
      this.page = 1;
      if (this.searchs.types.length>0) {
          if(this.searchs.types[0]){this.searchs.type_1=this.searchs.types[0]}
          if(this.searchs.types[1]){this.searchs.type_2=this.searchs.types[1]}
          if(this.searchs.types[2]){this.searchs.type_3=this.searchs.types[2]}
    }
      this.getList(this.page);
    },
    reset(){
      this.page = 1;
      this.searchs.name_cn="",
      this.searchs.name_en="",
      this.searchs.session_expo="",
      this.searchs.type_1="",
      this.searchs.type_2="",
      this.searchs.type_3="",
      this.searchs.types=[],
      this.getList(this.page);
    },
    //获取列表
    getList(page) {
      let data = this.$qs.stringify({
        page_size: this.pagesize,
        page_no: page,
        name_cn:this.searchs.name_cn,
        name_en:this.searchs.name_en,
        session_expo:this.searchs.session_expo,
        type_1:this.searchs.type_1,
        type_2:this.searchs.type_2,
        type_3:this.searchs.type_3
      });
      this.loading = true;
      productList(data)
        .then((res) => {
          //console.log(res, "======获取列表");
          if (res.code == 1) {
            this.loading = false;
            let { data } = res;
            let arr = data.lists;
            // arr.forEach(item => {
            //   if(item.product_type[0].productClass_1){
            //       var index = this.typeList.findIndex(function (titem) {
            //         return titem.itemid == item.product_type[0].productClass_1;
            //       });
            //       if(index >= 0){
            //         item.product_type[0].tname = this.typeList[index].name;
            //       }
            //   }
            // });
            this.tableData = arr;
            this.totals = data.count;
              this.product_max = data.product_max;
              this.allow_product = data.allow_product;

          }else{
            this.$message.warning(res.data)
          }
        })
        .catch((err) => {
          if(err.response.data.code != 401){
            this.$message.warning(err.response.data.data)
          }
        });
    },//产品分类
    getType(){
      // productType()
      //   .then(res => {
      //     //console.log(res, '======res')
      //     if(res.code == 200){
      //       this.typeList = res.data;
      //     }
      //   })
      //   .catch(err => {
      //
      //   })
    },
    // 跳转页面
    toLink(path) {
      let mark=this.mark;
      this.$router.push({
        path,
        query:{mark}
      });
    },
    // 返回
    goBack() {
      this.$router.back();
    },
    // 编辑
    edit(row){
      let mark=this.mark;
      this.$router.push({
        path: '/createProduct',
        query: {
          id: row.product_long_id,
          mark
        }
      });
    },// 删除
    del(index, row){
      this.$alert(`确定要删除吗？`, '', {
          confirmButtonText: '确定',
          callback: action => {
            console.log(action, '==action')
            if(action == 'confirm'){
              delproduct({product_long_id: row.product_long_id}).then(res => {
                  if(res.code == 1){
                    this.tableData.splice(index, 1);
                    this.totals = this.totals - 1;
                    this.$message.success(res.data.message);
                  }
                })
                .catch(err => {
                  console.log(err, '===err')
                })
            }
          }
        });
    },
    // 分页相关
    handleCurrentChange(val) {
      this.page = val;
      this.getList(this.page)
    },
  },
};
</script>

<style lang="scss" scoped>
    .times{
        width: 300px;
        color: red;
    }
    .right_box{

        display: flex;
        align-items: center;
    }
    .txt_box{

        margin-top: 25px;
        color: red;
    }
.list{
  background: #fff;
  padding: 30px;
  border-radius: 8px;
  box-sizing: border-box;
  
}
.search_item{
  display: flex;
  align-items: center;
  margin-bottom:22px;
  span{
    display: inline-block;
    width: 200px;
    text-align: right;
  }
}
.search-wrap{
  padding: 40px 20px 20px !important;
}
/deep/ .search-wrap .search-input .el-input{
  width: 85% !important;
}
.pagination_box{
  text-align: right;
  margin-top: 50px;
}
.goods_name{
  line-height: 20px;
  font-size:16px;
  font-weight: 600;
  color: #000;
}
.tname{
  font-size:14px;
  font-weight: 400;
  color: #000;
  margin-top: 15px;
}
.inputtime{
  font-size:12px;
  font-weight: 400;
  color: #969696;
  margin-top: 10px;
  line-height: 18px;
}
.p_footer{
  display: flex;
 
  .p_item_footer{
    width: 50%;
    height: 64px;
    line-height: 64px;
    text-align: center;
   
  }
  .p_item_footer:nth-child(1){
    border-right: 2px solid #eee;
  }
  
}
.header_box{
  width: 100%;
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 25px
}
 .create-btn {
    width: 148px;
    height: 42px;
    color: #fff;
    font-size: 19px;
    font-weight: 500;
    cursor: pointer;
    line-height: 42px;
    text-align: center;
    background: #1677ff;
    border-radius: 4px;
    &:hover{
      text-decoration: underline;
    }
  }
.content-type {
  padding-bottom: 35px;
  .main-title {
    width: 100%;
    margin-top: 40px;
  }
}
.p_list{
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  // background: #fff;
  // border-radius: 8px;
  padding: 20px 0 0;
  box-sizing: border-box;
}
.p_item{
     width: -webkit-calc((100% - 20px * 4)/ 4);
      width: calc((100% - 20px * 4) / 4);
      margin: 0 20px 20px 0;
      background: #fff;
      border-radius: 8px;
      padding: 20px 0 0;
      box-sizing: border-box;
}
.p_item_top{
  padding: 0 20px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .select_box{
    width: 80px;
  }
}
.p_item_scoend{
  margin-top: 10px;
  padding: 0 15px 15px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  border-bottom: 2px solid #eee;
  img{
    width: 100px;
    height: 100px;
    border-radius: 10px;
    margin-right: 20px;
  }
}
.search-wrap {
  width: 100%;
  background: #fff;
  border-radius: 8px;
  margin-top: 30px;
  align-items: center;
  justify-content: space-between;
  padding: 20px;
  box-sizing: border-box;
 
  margin-bottom: 20px;
  .search-input {
    align-items: center;
  }
  .search-input .search-btn {
    width: 130px;
    height: 42px;
   
    cursor: pointer;
    font-size: 19px;
    margin-right: 11px;
    line-height: 42px;
    text-align: center;
    // background: #2c2c2e;
    border-radius: 4px;
    &:hover{
      text-decoration: underline;
    }
  }
  .search{
    background: #008DFF;
    color: #fff;
  }
  .reset{
    color: #2690E6;
    border: 1px solid #008DFF;
    margin-left: 11px;
  }
 
}
.invitation-table{
  margin-top: 0 !important;
  padding-top: 0 !important;
  border-top: 0 none !important;
}
</style>
<style lang="scss">
.search-wrap {
  .search-input {
    .el-input {
      font-size: 14px;
      width: 40%;
    }
    .el-input__inner {
      height: 42px;
      line-height: 42px;
      border-radius: 4px;
    }
  }
}
.invitation-table .el-pagination {
  margin-top: 30px;
  text-align: center;
  .el-pager li,
  .el-pagination__total {
    font-size: 14px;
  }
  .el-pagination__jump {
    font-size: 14px;
  }
}
.my-table {
  color: #888;
  font-size: 18px;
  margin-top: 30px;
}
.my-table tbody td,
.my-table tbody th {
  height: 70px;
  padding: 5px 0;
  box-sizing: border-box;
}
.my-table tbody th,
.my-table tbody tr {
  background: #f2f6fb;
}
.my-table tbody tr.is-new {
  color: #0e0e0e;
}
.check-btn {
  color: #1677ff;
  cursor: pointer;
}
.check-btn:hover{
  text-decoration: underline;
}
.check-del {
  color: #ff4d4f;
 
}
.my-table tbody tr td .check-btn {
  color: #1677ff;
  cursor: pointer;
}
.my-table tbody tr td .check-btn:hover{
  text-decoration: underline;
}
.my-table tbody tr td .check-btn.check-del {
  color: #ff4d4f;

}
.el-table--striped .el-table__body tr.el-table__row--striped td {
  background: #fff;
}
.el-table td,
.el-table th.is-leaf {
  border-bottom: 0 none;
}
/* 表格最外层边框-底部边框 */
.el-table--border::after,
.el-table--group::after {
  width: 0;
}
.my-table::before {
  width: 0;
}
.my-table tbody tr td:first-child {
  border-radius: 10px 0 0 10px;
}
.my-table tbody tr td:last-child {
  border-radius: 0 10px 10px 0;
}
@media only screen and (max-width: 1366px) {
  .p_list{
    width: 100% !important;
  }
  .p_item{
     width: -webkit-calc((100% - 20px * 3)/ 3) !important;
      width: calc((100% - 20px * 3) / 3)!important;
      margin: 0 20px 20px 0 !important;
      background: #fff;
      border-radius: 8px;
      padding: 20px 0 0;
      box-sizing: border-box;
}
}
@media only screen and (max-width: 1280px) {
  .p_list{
  width: 100% !important;
 
}
  .p_item{
  
     width: -webkit-calc((100% - 15px * 2)/ 2) !important;
      width: calc((100% - 15px * 2) / 2)!important;
      margin: 0 15px 15px 0 !important;
      background: #fff;
      border-radius: 8px;
      padding: 20px 0 0;
      box-sizing: border-box;
}
}
@media only screen and (max-width: 1200px) {
  .p_list{
  width: 100% !important;
 
}
  .p_item{

     width: -webkit-calc((100% - 15px * 2)/ 2) !important;
      width: calc((100% - 15px * 2) / 2)!important;
    //   margin: 0 15px 15px 0 !important;
      background: #fff;
      border-radius: 8px;
      padding: 20px 0 0;
      box-sizing: border-box;
}
}
@media only screen and (max-width: 767px) {
  .el-pagination {
    padding: 2px 23px !important;
  }
  .p_item_footer{
    height: 54px!important;
    line-height: 54px!important;
    font-size:14px!important;
  }
  .tname{
    margin-top: 10px !important;
  }
  .inputtime{
    margin-top: 10px !important;
  }
  .p_item_scoend img{
    width: 80px !important;
    height: 81px !important;
    margin-right: 15px !important;
}
  .create-btn{
    width: 120px !important;
    height: 40px !important;
    font-size: 15px !important;
  }
  .search-wrap .search-input .search-btn{
    width: 130px!important;
    height: 40px!important;
    font-size: 15px !important;
  }
  .content{
    padding: 30px 0 130px 0;
  }
  .p_item{
    width: 100% !important;
    margin: 0 auto 20px !important;
  }
.p_list{
  width: 100% !important;
  margin-left: 0 !important;
  display: inline-block !important;
 
}
.search-wrap{
  width: 100% !important;
  margin:0 auto !important;
}
.search-input{
flex-wrap: wrap;
}
.el-input__inner{
  // width: 90% !important;
  margin: 20px 0;
}
.main-sub{
  width: 100%;
  padding-bottom: 8px !important;
}
.header_box{
 
  padding-bottom: 50px !important;
}
.create-btn{
  margin-bottom: 20px !important;
  position: absolute;
  right: 24px;
  bottom: 0;
}
.search-wrap .search-input .el-input{
  width: 100% !important;
}

}
</style>
<style>
@media only screen and (max-width: 767px) {
  .el-pagination {
    padding: 2px 23px !important;
  }
  .el-message-box{
      width: 350px !important;
    }
}
</style>